var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 26,
    viewBox: "0 0 18 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 427319551"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5 11H16V7.5C16 7.3674 15.9474 7.2402 15.8536 7.1464L12.8536 4.1464C12.7598 4.0528 12.6326 4 12.5 4H2.5C2.2238 4 2 4.2238 2 4.5V11H0.5C0.2238 11 0 11.2238 0 11.5V18.5C0 18.7762 0.2238 19 0.5 19H2V21.5C2 21.7762 2.2238 22 2.5 22H15.5C15.7762 22 16 21.7762 16 21.5V19H17.5C17.7762 19 18 18.7762 18 18.5V11.5C18 11.2238 17.7762 11 17.5 11ZM13 5.7072L14.293 7H13V5.7072ZM3 5H12V8H15V11H3V5ZM15 21H3V19H15V21ZM17 18H1V12H17V18Z",
    fill: "#939AA8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7 15.5V14.5C7 13.6728 6.3272 13 5.5 13H4V17H5.5C6.3272 17 7 16.3272 7 15.5ZM5 14H5.5C5.7756 14 6 14.2242 6 14.5V15.5C6 15.7758 5.7756 16 5.5 16H5V14Z",
    fill: "#939AA8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9 17C9.8272 17 10.5 16.3272 10.5 15.5V14.5C10.5 13.6728 9.8272 13 9 13C8.1728 13 7.5 13.6728 7.5 14.5V15.5C7.5 16.3272 8.1728 17 9 17ZM8.5 14.5C8.5 14.2242 8.7244 14 9 14C9.2756 14 9.5 14.2242 9.5 14.5V15.5C9.5 15.7758 9.2756 16 9 16C8.7244 16 8.5 15.7758 8.5 15.5V14.5Z",
    fill: "#939AA8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.5 17H14V16H12.5C12.2244 16 12 15.7758 12 15.5V14.5C12 14.2242 12.2244 14 12.5 14H14V13H12.5C11.6728 13 11 13.6728 11 14.5V15.5C11 16.3272 11.6728 17 12.5 17Z",
    fill: "#939AA8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadDoc);
export default __webpack_public_path__ + "static/media/downloadDoc.7dd233cd0245c952cb2db73f834e3382.svg";
export { ForwardRef as ReactComponent };